import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "M24.906 8.89a.93.93 0 0 1-.96-.923v-1.92a.926.926 0 0 1 .987-.945 18.6 18.6 0 0 1 6.252 1.37A18.92 18.92 0 1 1 6.468 31.19 18.57 18.57 0 0 1 5.1 25.028v-.117a.96.96 0 0 1 .96-.96h1.92a1.032 1.032 0 0 1 .957 1.089c.03.623.105 1.242.225 1.854a15.082 15.082 0 1 0 25.452-13.605 14.823 14.823 0 0 0-9.651-4.395l-.057-.003Z" }, null, -1), r = [
  c
];
function a(s, l) {
  return e(), t("svg", n, r);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
//# sourceMappingURL=spinner.svg.mjs.map
